import { usePathname, useParams } from 'next/navigation';

const validPaths = ['/live', '/sports', '/section', '/world'];

export const useIsOddsListPage = () => {
	const pathname = usePathname();
	const params = useParams();

	const isOddsPage = !params.matchId && validPaths.some(path => pathname.includes(path));

	return isOddsPage;
};